import useNavigate from '@/hooks/router/useNavigate';
import { Paper, styled, Typography } from '@mui/material';
import { ScopeForm, ClientConfigurationContext } from '@ngt/openiddict'
import { FC, useCallback, useContext } from 'react';
import { useParams } from 'react-router-dom';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2)
}))

const Scope: FC = () => {
    const navigate = useNavigate();

    const { id } = useParams();
    
    const { data: clientConfiguration } = useContext(ClientConfigurationContext);

    const onCancel = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.scopes ?? '/');
    }, [navigate, clientConfiguration?.administrationUris?.scopes])

    const afterDelete = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.scopes ?? '/', { replace: true });
    }, [navigate, clientConfiguration?.administrationUris?.scopes]);

    const afterSubmit = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.scopes ?? '/', { replace: true });
    }, [navigate, clientConfiguration?.administrationUris?.scopes])

    return (
        <>
            <Typography variant="h1" gutterBottom>
                Scope
            </Typography>
            <StyledPaper>
                <ScopeForm
                    id={id && !isNaN(+id) ? +id : undefined}
                    afterDelete={afterDelete}
                    afterSubmit={afterSubmit}
                    onCancel={onCancel}
                    debug={import.meta.env.DEV}
                />
            </StyledPaper>
        </>
    );
}

export default Scope;